var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3637 12.1318C22.0001 12.1318 21.7501 12.3818 21.7501 12.7455V19.3364C21.7501 19.5864 21.591 19.7227 21.3637 19.7227H3.13646C2.88646 19.7227 2.7501 19.5637 2.7501 19.3364V12.7455C2.7501 12.3818 2.5001 12.1318 2.13646 12.1318C1.77283 12.1318 1.52283 12.3818 1.52283 12.7455V19.3364C1.52283 20.2682 2.22737 20.9727 3.15919 20.9727H21.3865C22.3183 20.9727 23.0228 20.2682 23.0228 19.3364V12.7455C23.0001 12.3818 22.7501 12.1318 22.3637 12.1318Z",
    fill: "#809199"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8636 5.0411H16.2955V4.72292C16.2955 3.85929 15.6364 3.2002 14.7727 3.2002H9.72727C8.86364 3.2002 8.20455 3.85929 8.20455 4.72292V5.0411H2.63636C1.70455 5.0411 1 5.74565 1 6.67747V9.92747C1 10.6775 1.52273 11.3366 2.25 11.4957L10.2273 13.2684V14.3366C10.2273 14.632 10.4318 14.8366 10.7273 14.8366H13.7727C14.0682 14.8366 14.2727 14.632 14.2727 14.3366V13.2684L22.25 11.4957C22.9773 11.3366 23.5 10.6547 23.5 9.92747V6.67747C23.5 5.74565 22.7955 5.0411 21.8636 5.0411ZM22.25 9.90474C22.25 10.1093 22.1364 10.2684 21.9318 10.2911L14.2727 12.0184V11.7002V11.2911C14.2727 10.9956 14.0682 10.7911 13.7727 10.7911H10.7273C10.4318 10.7911 10.2273 10.9956 10.2273 11.2911V11.7002V12.0184L2.54545 10.2911C2.36364 10.2684 2.25 10.1093 2.25 9.90474V6.67747C2.25 6.42747 2.40909 6.2911 2.63636 6.2911H21.8636C22.1136 6.2911 22.25 6.4502 22.25 6.67747V9.90474Z",
    fill: "#809199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleIcon);
export default __webpack_public_path__ + "static/media/role-icon.07a6bd5b4532ff95d6f1895dc775d7cb.svg";
export { ForwardRef as ReactComponent };